<template>
  <ul v-if="attachments.length > 0">
    <li v-for="attachment in attachments" :key="attachment.url">
      <a :href="attachment.url" target="_blank" data-jest="attachment">{{ attachment.alt || attachment.fileName }}</a>
    </li>
  </ul>
</template>

<script setup lang="ts">
import type { ProductAttachment } from '~/types/product'

defineProps<{
  attachments: ProductAttachment[]
}>()
</script>
